import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useTranslate } from 'react-admin';
import { OrderModel } from '../../../config/types/models/OrderModel';
import { UserModel } from '../../../config/types/models/UserModel';
import { useSettings } from '../../../hooks/settings/useSettings';

type IProps = {
  order: OrderModel;
};
function OrderInfoSection({ order }: IProps) {
  const { data: settings } = useSettings();
  const t = useTranslate();
  return (
    <Box>
      <Typography>{`${t('id')}: ${order.id}`}</Typography>
      <Typography>{`${t('shippingAddres')}: ${
        order.shippingAddress
      }`}</Typography>
      <Typography>{`${t('paymentStatus')}: ${order.paymentStatus}`}</Typography>
      <Typography>{`${t('total')}:  ${order.total} ${
        settings.currency
      } `}</Typography>
    </Box>
  );
}

export default OrderInfoSection;
